import store from '../store/index.js'
import util from './util'
// 配置API接口地址
var root = _myconfig.apiBaseUrl;
// var root = 'http://117.78.26.126:9841'
// 引用axios
var axios = require('axios')
// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
axios.interceptors.request.use(
  config => {

    if (store.state.token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = "Bearer " + store.state.token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

function apiAxios(method, url, params, success, failure, useBaseURL) {
  if (params) {
    params = filterNull(params)
  }
  let baseURL = '';
  if (useBaseURL) {
    baseURL = root;
  }
  axios({
      method: method,
      url: url,
      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,
      //headers 是即将被发送的自定义请求头
      // headers:{'Content-Type': 'application/json;charset=utf-8'},
      baseURL: baseURL,
      withCredentials: false
    })
    .then(function (res) {

      if (success) {
        success(res.data)
      }

    })
    .catch(function (err) {
      let res = err.response;
      if (failure) {
        failure();
      } else if (res) {
        console.log(res);
        //window.alert('api error, HTTP CODE: ' + res.status)
      } else {
        console.log(err);
      }
    })
}


function downloadfile(method, url, params, responseType, success, failure, useBaseURL) {
  method = method.toUpperCase();
  if (params) {
    params = filterNull(params)
  }
  let baseURL = '';
  if (useBaseURL) {
    baseURL = root;
  }

  axios({
      method: method,
      url: url,
      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,


      responseType: responseType,
      baseURL: baseURL,
      withCredentials: false
    })
    .then(function (res) {
      let r = new FileReader();
      r.onload = function () {
        // 如果JSON.parse不报错，说明是json字符串，是下载报错情况的返回值，弹框提示
        // 如果JSON.parse报错，说明下载成功，进入catch
        try {
          let resData = JSON.parse(this.result)
          if (resData && resData['code'] && resData['code'] != 200) {
            alert(resData.msg);
          }
        } catch (err) {
          let fileName = res.headers['filename']; // 获取文件名，这里的头需要后台设置可获取自定义header
          fileName = decodeURIComponent(fileName);

          util.downloadFile(res.data, "", fileName);
        }
      }
      r.readAsText(res.data);
      if (success) {
        success(res.data)
      }
    })
    .catch(function (err) {
      let res = err.response;
      if (failure) {
        failure();
      } else if (res) {
        console.log(res);
      } else {
        console.log(err);
      }
    })
}

function createGetFun(urls, params, useBaseURL) {
  let baseURL = '';
  if (useBaseURL) {
    baseURL = root;
  }
  let funs = [];
  for (let index = 0; index < urls.length; index++) {
    const url = urls[index];
    const param = params[index];
    let fun = axios.get(url, {
      params: param,
      baseURL: baseURL,
      withCredentials: false
    });
    funs.push(fun);
  }
  return funs;
}

function apiAxiosAll(urls, params, success, failure, useBaseURL) {
  if (params) {
    params = filterNull(params)
  }
  let funs = createGetFun(urls, params, useBaseURL);
  axios.all(funs)
    .then(axios.spread(function (res1, res2, res3, res4, res5, res6, res7, res8, res9, res10) {
      if (success) {
        success([res1, res2, res3, res4, res5, res6, res7, res8, res9, res10]);
      }
    })).catch(function (err) {
      let res = err.response;
      if (failure) {
        failure();
      } else if (res) {
        console.log(res);
      } else {
        console.log(err);
      }
    });
}

// 返回在vue模板中的调用接口,useBaseUrl 是否使用baseURL
export default {
  get: function (url, params, success, failure, useBaseURL = true) {
    return apiAxios('GET', url, params, success, failure, useBaseURL)
  },
  post: function (url, params, success, failure, useBaseURL = true) {
    return apiAxios('POST', url, params, success, failure, useBaseURL)
  },
  put: function (url, params, success, failure, useBaseURL = true) {
    return apiAxios('PUT', url, params, success, failure, useBaseURL)
  },
  delete: function (url, params, success, failure, useBaseURL = true) {
    return apiAxios('DELETE', url, params, success, failure, useBaseURL)
  },
  axios: function (method, url, params, success, failure, useBaseURL = true) {
    return apiAxios(method, url, params, success, failure, useBaseURL)
  },
  downloadFile: function (method, url, params, success, failure, useBaseURL = true) {
    return downloadfile(method, url, params, 'blob', success, failure, useBaseURL)
  },
  all: function (urls, params, success, failure, useBaseURL = true) {
    return apiAxiosAll(urls, params, success, failure, useBaseURL)
  }
}